import Vue from 'vue'
import Router from 'vue-router'

// 新系统首页
import HistoryNewHome from '../pages/history/history-home.out.vue'

// 历史库index页
import HistoryIndex from '../pages/history-index.vue'

// 其他页indx页 和历史库index页的不同之处主要在于头部的不同
import homePage from '../pages/other-index'

// 编年页面
import chronology from '../pages/chronology-out/chronology.vue'
import chronologySearch from '../pages/chronology-out/chronologySearch.vue'

// 全库检索
import fullLibSearch from '../pages/fullLibSearch-out/fullLibSearch.vue'

// 历史库下的子页面
import HistoryArea from '../pages/history/history-area.vue'
import HistoryEvent from '../pages/history/history-event.vue'
import HistoryPerson from '../pages/history/history-person.vue'
import HistoryMechanism from '../pages/history/history-mechanism.vue'
import HistoryRegion from '../pages/history/history-region.vue'
import HistoryAccount from '../pages/history/history-account.vue'
import HistoryObject from '../pages/history/history-object.vue'
import HistoryCird from '../pages/history/history-cird.vue'

// 视频播放
import videoPlayer from '../modules/history/videoPlayer.vue'

import article from '@/modules/history/article-view'
import column from '@/modules/history/column-view'

import historyIntro from '@/modules/history/intro'

// 新个人中心
import userInformation from '@/pages/member-manage-out/user-info'
import resetPassword from '@/pages/member-manage-out/password-reset.vue'
// 新个人中心结束

// 关于我们
import aboutUs from '@/modules/common/about-us.vue'
// 版权声明
import copyright from '@/modules/common/copyright.vue'

Vue.use(Router)

var routesConfig = [
  {
    path: '/',
    redirect: 'chronology'
  },
  {
    path: '/historyHome',
    name: 'historyNewHome',
    component: HistoryNewHome
  },
  {
    path: '/history',
    component: HistoryIndex,
    children: [
      {
        path: '/historyArea',
        name: 'historyArea',
        component: HistoryArea
      },
      {
        path: '/historyEvent/:type/:time?/:year?/:column?/:propType?',
        name: 'historyEvent',
        component: HistoryEvent
      },
      {
        path: '/historyPerson/:type/:time?/:column?/:propType?',
        name: 'historyPerson',
        component: HistoryPerson
      },
      {
        path: '/historyMechanism/:type/:time?/:year?/:column?/:propType?',
        name: 'historyMechanism',
        component: HistoryMechanism
      },
      {
        path: '/historyRegion/:type/:time?/:column?/:propType?',
        name: 'historyRegion',
        component: HistoryRegion
      },
      {
        path: '/historyAccount/:type/:time?/:column?/:propType?',
        name: 'historyAccount',
        component: HistoryAccount
      },
      {
        path: '/HistoryObject/:type/:time?/:column?/:propType?',
        name: 'HistoryObject',
        component: HistoryObject
      },
      {
        path: '/HistoryCird/:type/:time?/:column?/:propType?',
        name: 'HistoryCird',
        component: HistoryCird
      }
    ]
  },
  {
    path: '/homePage',
    component: homePage,
    children: [
      {
        path: '/chronology',
        name: 'chronology',
        component: chronology
      },
      {
        path: '/chronologySearch',
        name: 'chronologySearch',
        component: chronologySearch
      },
      {
        path: '/fullLibSearch',
        name: 'fullLibSearch',
        component: fullLibSearch
      },
      {
        path: '/userInformation',
        name: 'userInformation',
        component: userInformation
      },
      {
        // 独立的栏目页
        path: '/column/:library/:column/:propType?',
        name: 'column',
        component: column
      },
      {
        path: '/article/:id',
        name: 'article',
        component: article
      },
      {
        path: '/aboutUs/:id',
        name: 'aboutUs',
        component: aboutUs
      },
      {
        path: '/copyright',
        name: 'copyright',
        component: copyright
      },
      {
        path: '/intro/:id',
        name: 'intro',
        component: historyIntro
      },
      {
        path: '/resetPassword/:type',
        name: 'resetPassword',
        component: resetPassword
      },
      {
        path: '/videoPlayer',
        name: 'videoPlayer',
        component: videoPlayer
      }
    ]
  }
]

const router = new Router({
  routes: routesConfig
})

export default router



// WEBPACK FOOTER //
// ./src/router/indexOut.js